module.exports = __webpack_public_path__ + "static/jara-e39054d01c8fa5ad68f47caa7e9888e2.png";